import { render, staticRenderFns } from "./CalvingDetails.vue?vue&type=template&id=2ad63d2b&scoped=true&"
import script from "./CalvingDetails.vue?vue&type=script&lang=js&"
export * from "./CalvingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad63d2b",
  null
  
)

export default component.exports